import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-20 md:py-32 px-5" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        {/* Problem headline */}
        <ScrollReveal data-id="element-109">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-8" data-id="element-110">
            El problema real no es tu contenido…{' '}
            <span className="font-serif-italic text-accent" data-id="element-111">
              Es tu entrada.
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-112">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-neutral-300" data-id="element-113">
            <p data-id="element-114">
              Porque aunque tengas algo valioso que decir, el espectador no lo
              sabe.
            </p>
            <div className="space-y-1" data-id="element-115">
              <p data-id="element-116">En el scroll, nadie te da contexto.</p>
              <p data-id="element-117">Nadie te da "chance".</p>
              <p data-id="element-118">Nadie espera a que "agarres ritmo".</p>
            </div>
            <p className="text-white font-bold text-xl md:text-2xl" data-id="element-119">
              Te juzgan en 1–3 segundos.
            </p>
            <p data-id="element-120">
              Si no hay tensión, curiosidad, beneficio o contraste…{' '}
              <span className="text-accent font-bold" data-id="element-121">se van.</span>
            </p>
          </div>
        </ScrollReveal>

        {/* Divider */}
        <div className="my-16 md:my-24 h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-122" />

        {/* Failed solutions */}
        <ScrollReveal data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-10" data-id="element-124">
            Lo que la mayoría intenta{' '}
            <span className="text-neutral-500" data-id="element-125">(y por qué no funciona)</span>
          </h2>
        </ScrollReveal>

        <div className="space-y-5" data-id="element-126">
          <ScrollReveal delay={0.05} data-id="element-127">
            <div className="flex gap-4 items-start bg-surface/60 border border-border rounded-xl p-5 md:p-6" data-id="element-128">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-129">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-130" />
              </div>
              <div data-id="element-131">
                <p className="text-white font-bold mb-1" data-id="element-132">
                  Copiar ganchos virales
                </p>
                <p className="text-neutral-400" data-id="element-133">
                  suenas actuado o fuera de lugar.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.1} data-id="element-134">
            <div className="flex gap-4 items-start bg-surface/60 border border-border rounded-xl p-5 md:p-6" data-id="element-135">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-136">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <p className="text-white font-bold mb-1" data-id="element-139">Meter más edición</p>
                <p className="text-neutral-400" data-id="element-140">
                  bonito, pero igual se van si entras flojo.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-141">
            <div className="flex gap-4 items-start bg-surface/60 border border-border rounded-xl p-5 md:p-6" data-id="element-142">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-143">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-144" />
              </div>
              <div data-id="element-145">
                <p className="text-white font-bold mb-1" data-id="element-146">Depender de trends</p>
                <p className="text-neutral-400" data-id="element-147">
                  cuando no hay trend, te quedas sin plan.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-148">
            <div className="flex gap-4 items-start bg-surface/60 border border-border rounded-xl p-5 md:p-6" data-id="element-149">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center mt-0.5" data-id="element-150">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-151" />
              </div>
              <div data-id="element-152">
                <p className="text-white font-bold mb-1" data-id="element-153">
                  Empezar con "Hola, soy…"
                </p>
                <p className="text-neutral-400" data-id="element-154">
                  es el equivalente a decir "ignórame".
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.25} data-id="element-155">
          <p className="mt-10 text-lg md:text-xl text-neutral-300 leading-relaxed" data-id="element-156">
            La gente no necesita que le expliques tu tema…{' '}
            <span className="text-white font-bold" data-id="element-157">
              necesita que le des una razón para quedarse.
            </span>
          </p>
        </ScrollReveal>
      </div>
    </section>;
}